module.exports = __webpack_public_path__ + "static/media/visitbrussels_5.b89651a3.jpg";